// /api/v1/me — caller's own profile + SSH keys.

import useSWR from 'swr';
import { parseErrorResponse } from './problem';

export interface SSHKey {
  id: string;
  name: string;
  fingerprint: string;
  public_key?: string;
  created_at: string;
  last_used_at?: string;
}

const fetcher = async (url: string) => {
  const r = await fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } });
  if (!r.ok) throw await parseErrorResponse(r);
  return r.json();
};

export function useSSHKeys() {
  return useSWR<SSHKey[]>('/api/v1/me/ssh-keys', fetcher);
}

export async function addSSHKey(input: { name: string; public_key: string }): Promise<SSHKey> {
  const res = await fetch('/api/v1/me/ssh-keys', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(input),
  });
  if (!res.ok) throw await parseErrorResponse(res);
  return res.json();
}

export async function deleteSSHKey(id: string): Promise<void> {
  const res = await fetch(`/api/v1/me/ssh-keys/${id}`, {
    method: 'DELETE', credentials: 'include',
  });
  if (!res.ok && res.status !== 204) throw await parseErrorResponse(res);
}
